/* Opt-in table display enhancement. Does not select variants or collect personal data. */
(() => {
class LoliroomSizeUnits extends HTMLElement {
  connectedCallback() {
    if(this.dataset.enhanced || this.dataset.measurementKind!=='garment' || this.dataset.chartScope!=='haruhime-black-style-1')return;
    const content=this.querySelector('.loliroom-size-fit-content');
    if(!content)return;
    const text=node=>node?.textContent.replace(/\s+/g,' ').trim();
    const sections=[...content.querySelectorAll('section.loliroom-size-fit-section')].filter(section=>text(section.querySelector(':scope > h3'))==='Black short-sleeve blouse (Style 1)');
    if(sections.length!==1)return;
    const section=sections[0];
    if(text(section.querySelector(':scope > p'))!=='Finished garment measurements in centimetres. For the Black - Short Sleeve Blouse option only; not for Style 2 or detachable sleeves.')return;
    const tables=[...section.querySelectorAll('table')];
    if(tables.length!==1)return;
    const scroll=tables[0].parentElement;
    if(!scroll.classList.contains('loliroom-size-fit-table-scroll') || scroll.parentElement!==section)return;
    const changes=[];
    const parse=text=>{
      const m=text.trim().match(/^(\d+(?:\.\d+)?)(?:\s*[-–]\s*(\d+(?:\.\d+)?))?$/);
      if(!m)return null;
      const numbers=m.slice(1).filter(v=>v!==undefined).map(Number);
      return numbers.every(n=>Number.isFinite(n)&&n>=0) && (numbers.length===1||numbers[0]<=numbers[1])?numbers:null;
    };
    for(const table of tables){
      const headers=[...table.querySelectorAll('thead th')];
      if(!headers.length || table.querySelectorAll('thead tr').length!==1 || headers[0].textContent.trim()!=='Size' || new Set(headers.map(h=>h.textContent.trim())).size!==headers.length)continue;
      if([...table.querySelectorAll('th,td')].some(cell=>cell.children.length || cell.colSpan!==1 || cell.rowSpan!==1))continue;
      const columns=headers.map((h,i)=>/\(cm\)\s*$/.test(h.textContent)&&/^(Length|Shoulder|Bust|Waist)\b/.test(h.textContent)?i:-1).filter(i=>i>=0);
      if(columns.length!==headers.length-1)continue; // Ambiguous headers remain original.
      const current=[];let valid=true;
      for(const tr of table.querySelectorAll('tbody tr')){
        if(tr.children.length!==headers.length){valid=false;break;}
        for(const i of columns){
          const cell=tr.children[i];const original=cell.textContent;
          if(cell.children.length){valid=false;break;}
          const numbers=parse(original);
          if(!numbers && !/^\s*(?:—|–|-|N\/A)\s*$/.test(original)){valid=false;break;}
          current.push({cell,original,numbers});
        }
      }
      if(valid&&current.length){changes.push(...current,...columns.map(i=>({cell:headers[i],original:headers[i].textContent,header:true})));}
    }
    if(!changes.length)return;
    this.dataset.enhanced='true';
    const bar=document.createElement('div');bar.className='lr-size-unit-toolbar';
    const label=document.createElement('span');label.textContent='Table units';
    const group=document.createElement('div');group.setAttribute('role','group');group.setAttribute('aria-label','Size table measurement unit');
    const note=document.createElement('p');note.className='lr-size-unit-note';note.setAttribute('aria-live','polite');
    const buttons=['cm','in'].map(unit=>{const button=document.createElement('button');button.type='button';button.textContent=unit;button.setAttribute('aria-pressed',String(unit==='cm'));button.addEventListener('click',()=>setUnit(unit));group.append(button);return button;});
    function setUnit(unit){
      for(const item of changes){item.cell.textContent=unit==='cm'?item.original:item.header?item.original.replace(/\(cm\)\s*$/,'(in ≈)'):item.numbers?item.numbers.map(n=>(n/2.54).toFixed(1)).join('–'):item.original;}
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.textContent===unit)));
      note.textContent=unit==='cm'?'Black Style 1 table in cm.':'Black Style 1 table in approximate inches. Fit notes stay in cm.';
    }
    bar.append(label,group);scroll.before(bar,note);setUnit('cm');
  }
}
if(!customElements.get('loliroom-size-units'))customElements.define('loliroom-size-units',LoliroomSizeUnits);
})();
